RESET_PAYMENT_TEST_CODE